import { createSelector } from 'reselect';
import { INIT_STATE } from '../reducers/MicroFrontendsReducer';
import type {
  MicroFrontendsReducer,
  QltConfig,
  JourneysCreativeOptimizationConfig,
  PostbacksFormConfig,
  LinkManagerConfig,
  AlertNotificationsConfig,
  QrCodeCustomizationsConfig,
  UsageConfig,
  DiscoDashboardConfig,
} from '../types/microFrontendReducerTypes';

export function getMicroFrontendsState(state: any): MicroFrontendsReducer {
  return (state && state.micro_frontends) || INIT_STATE;
}

export const getMicroFrontendsVersions: (state: any) => Record<string, string> = createSelector(
  getMicroFrontendsState,
  (state) => state && state.versions
);

export const getQuickLinkTemplateMicroFrontendConfig: (state: any) => QltConfig = createSelector(
  getMicroFrontendsState,
  (state) => state && state.qlt
);

export const getLinkManagerConfig: (state: any) => LinkManagerConfig = createSelector(
  getMicroFrontendsState,
  (state) => state && state.linkManager
);

export const getJourneysCreativesOptimizationConfig: (state: any) => JourneysCreativeOptimizationConfig = createSelector(
  getMicroFrontendsState,
  (state) => state && state.journeysCreativesOptimization
);

export const getPostbacksFormConfig: (state: any) => PostbacksFormConfig = createSelector(
  getMicroFrontendsState,
  (state) => state && state.postbacksForm
);

export const getAlertNotificationsConfig: (state: any) => AlertNotificationsConfig = createSelector(
  getMicroFrontendsState,
  (state) => state && state.alertNotifications
);

export const getQrCodeCustomizationsConfig: (state: any) => QrCodeCustomizationsConfig = createSelector(
  getMicroFrontendsState,
  (state) => state && state.qrCodeCustomizations
);

export const getUsageConfig: (state: any) => UsageConfig = createSelector(
  getMicroFrontendsState,
  (state) => state && state.usage
);

export const getDiscoDashboardConfig: (state: any) => DiscoDashboardConfig = createSelector(
  getMicroFrontendsState,
  (state) => state && state.discoDashboard
);

export const isLoading: (state: any) => boolean = createSelector(
  getMicroFrontendsState,
  (state) => state && state.isLoading
);
